import { FormValidation, UiSchema } from "@rjsf/utils";

/**
 * Walks the uiSchema and formData recursively, adding a validation error
 * for any field whose current value appears in its `ui:enumDisabled` list.
 *
 * This prevents submitting a form with a value that is only disabled in the
 * UI (e.g. IMBRO/A-only options when the IMBRO quality regime is active).
 */
export function validateDisabledEnum<T extends Record<string, unknown>>(
  uiSchema: UiSchema | undefined,
  formData: T | undefined,
  errors: FormValidation<T>
): void {
  if (!uiSchema || !formData) return;

  for (const key of Object.keys(uiSchema)) {
    if (key.startsWith("ui:")) continue;

    const fieldUiSchema = uiSchema[key] as UiSchema | undefined;
    const fieldValue = formData[key];
    const disabledValues = fieldUiSchema?.["ui:enumDisabled"] as string[] | undefined;

    if (disabledValues && disabledValues.includes(String(fieldValue))) {
      errors[key]?.addError("This option is not available for the selected quality regime");
    }

    // Recurse into nested objects
    if (fieldValue && typeof fieldValue === "object" && !Array.isArray(fieldValue)) {
      const childErrors = errors[key];
      if (childErrors) {
        validateDisabledEnum(fieldUiSchema, fieldValue as Record<string, unknown>, childErrors);
      }
    }
  }
}
